// UploadFastaService.ts

import type { IFastaRepository } from "@domain/repositories";
import { FastaFile } from "@domain/schemas/BI";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";

@injectable()
class UploadFastaService {
  @inject(TYPES.IFastaRepository)
  private _fastaRepository!: IFastaRepository;

  async uploadFastaAsync(projectId: string, file: File, onProgress: (progress: number) => void, rootPath?: string, folder?: string): Promise<FastaFile> {
    return this._fastaRepository.uploadFileAsync(projectId, file, onProgress, rootPath, folder);
  }

  async checkFastaFileExistsAsync(projectId: string, fileName: string, rootPath?: string, folder?: string): Promise<number | null> {
    return this._fastaRepository.checkFileExistsAsync(projectId, fileName, rootPath, folder);
  }
}

export { UploadFastaService };
